function Clientes() {
    return (
        <section className="clientes">
            <div className="wrap">
                <div className="sec-title">
                    <h2>Clientes</h2>
                    <div className="bar"></div>
                </div>
                <div className="clientes-card">


                    <div className="cl-logos">
                        <div className="cl">
                            <img
                                className="cl-img"
                                // src="img/clients/aecom.svg"
                                src="../img/clients/aecom.svg"
                                alt="AECOM"
                            />
                        </div>

                        <div className="cl cl-pucp-lock">
                            <img
                                className="cl-img"
                                src="../img/clients/pucp.png"
                                alt="PUCP"
                            />

                            {/* <div className="cl-pucp-txt">
                                <b>PUCP</b>
                                <small>Pontificia Universidad Católica</small>
                            </div> */}
                        </div>

                        <div className="cl">
                            <img
                                className="cl-img cl-bechtel-img"
                                src="../img/clients/bechtel.svg"
                                alt="Bechtel"
                            />
                        </div>

                        <div className="cl">
                            <img
                                className="cl-img cl-cps-img"
                                src="../img/clients/cps.png"
                                alt="CPS de Ingeniería"
                            />
                        </div>
                    </div>
                </div>

                <div className="cl-rule"></div>
            </div>
        </section>
    );
}

export default Clientes;